import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=20a30e9b&lang=less"
import "./index.vue?vue&type=style&index=1&id=20a30e9b&lang=less&scoped=true"
script.__scopeId = "data-v-20a30e9b"

export default script